import { render } from "./SheetSongModal.vue?vue&type=template&id=1814227a"
import script from "./SheetSongModal.vue?vue&type=script&lang=js"
export * from "./SheetSongModal.vue?vue&type=script&lang=js"

import "./SheetSongModal.vue?vue&type=style&index=0&id=1814227a&lang=css"
script.render = render

export default script